export default __webpack_public_path__ + "static/media/NH.1b6175ad.png";